import { invalidateBatteryConcertApplication } from "~/api/hooks/battery-concert-application-cache"

import { useConcertApplicationNotifications } from "../../../ProposalSetup/financing/concert/use-concert-application-notifications"

export { ACTIVE_LOAN_STATUS_UPDATED_EVENT } from "../../../ProposalSetup/financing/concert/use-concert-application-notifications"

/**
 * Refetch the Concert application, financing, and financial-summary reads
 * when the gateway publishes an application change for this Proposal.
 */
export function useBatteryConcertApplicationNotifications(
  proposalId: string | undefined,
): void {
  useConcertApplicationNotifications(
    proposalId,
    invalidateBatteryConcertApplication,
  )
}
